import { downgradeComponent } from '@angular/upgrade/static';

import { PolicyEngineComponent } from './policyEngine';
import { PolicyEngineMenuComponent } from './policy-engine-menu/policy-engine-menu.component';
import { PolicyManagementComponent } from './policy-management/policy-management.component';

import { TranformtionPolicyRulesServerToClientFilterObject } from './transofromtions/trans.policyRulesServerToClient';
import { TranformtionPoliciesServerToClientFilterObject } from './transofromtions/trans.policiesServerToClient';
import { TranformtionPolicyServerToClientFilterObject } from './transofromtions/trans.policyServerToClient';
import { TranformtionEnforcmentServerToClientFilterObject } from './transofromtions/trans.enforcmentServerToClient';
import {RulesManagementComponent} from "@app/authorized/policyEngine/rules-management/rules-management.component";
import {RuleItemComponent} from "@app/authorized/policyEngine/rules-management/rule-item/rule-item.component";
import {RuleListComponent} from "@app/authorized/policyEngine/rules-management/rule-list/rule-list.component";
import {EnforcementComponent} from "@app/authorized/policyEngine/policy-enforcement/enforcement/enforcement.component";
import {PolicyEnforcementComponent} from "@app/authorized/policyEngine/policy-enforcement/policy-enforcement.component";

export default angular.module('policyEngine',[])
    .component('policyEngine', PolicyEngineComponent)
    .directive('policyEngineMenu', downgradeComponent({ component: PolicyEngineMenuComponent }))
    .directive('rulesManagement', downgradeComponent({ component: RulesManagementComponent }))
    .directive('ruleItem', downgradeComponent({ component: RuleItemComponent }))
    .directive('ruleList', downgradeComponent({ component: RuleListComponent }))
    .directive('policyManagement', downgradeComponent({ component: PolicyManagementComponent }))
    .directive('policyEnforcement', downgradeComponent({ component: PolicyEnforcementComponent }))
    .directive('enforcement', downgradeComponent({ component: EnforcementComponent }))
    .filter(TranformtionPolicyRulesServerToClientFilterObject.name, TranformtionPolicyRulesServerToClientFilterObject.filter)
    .filter(TranformtionPoliciesServerToClientFilterObject.name, TranformtionPoliciesServerToClientFilterObject.filter)
    .filter(TranformtionPolicyServerToClientFilterObject.name, TranformtionPolicyServerToClientFilterObject.filter)
    .filter(TranformtionEnforcmentServerToClientFilterObject.name, TranformtionEnforcmentServerToClientFilterObject.filter);




// WEBPACK FOOTER //
// ./src/app/authorized/policyEngine/index.js